// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import BaseViewModel from "./../factories/base-view-model";
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-pager";
import BaoDialogViewModel from "../factories/bao-dialog";

function TicketAbonnementViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(this, tabPage);
    self.Bao = Bao;
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.TicketAbonnementCollection = ko.observableArray([]);
    self.SelectedTicketAbonnementId = ko.observable();
    self.SelectedTicketAbonnement = ko.observable();
    self.SelectedTicketAbonnementRow = ko.observable({});
    self.PageIndex.subscribe(function () {
        self.PerformRefresh();
    });
    self.Sorting.subscribe(function () {
        self.PerformRefresh();
    });
    self.SelectedTicketAbonnementRow.subscribe(function () {
        if (self.SelectedTicketAbonnementRow() == null) {
            BaoMenu.permissionEnable({
                ActionKey: "TicketAbonnementEdit",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "TicketAbonnementDelete",
                Enabled: false,
                Context: tabPage.Context()
            });
        }
        else {
            BaoMenu.permissionEnable({
                ActionKey: "TicketAbonnementEdit",
                Enabled: true,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "TicketAbonnementDelete",
                Enabled: true,
                Context: tabPage.Context()
            });
        }
    });
    self.PerformRefresh = function () {
        var def = $.Deferred();
        self.RefreshGrid().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketAbonnement/GetTicketAbonnementCollection", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedTicketAbonnementRow(null);
            self.TotalRows(0);
            self.TicketAbonnementCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TicketAbonnementCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.Save = function () {
        return;
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.init = function () {
        return self.PerformRefresh();
    };
    self.loaded = function () {
        return;
    };
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketAbonnement");
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            switch (value.ActionKey()) {
                case "TicketAbonnementAdd":
                    self.ShowTicketAbonnementDialog(null);
                    break;
                case "TicketAbonnementEdit":
                    if (self.SelectedTicketAbonnementRow() != null) {
                        self.EditTicketAbonnement(self.SelectedTicketAbonnementRow());
                    }
                    break;
                case "TicketAbonnementDelete":
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteTicketAbonnement(self.SelectedTicketAbonnementRow().TicketAbonnementId);
                        }
                    });
                    break;
            }
        }
    }));
    self.EditTicketAbonnement = function (item) {
        self.ShowTicketAbonnementDialog(item.TicketAbonnementId);
    };
    self.ShowTicketAbonnementDialog = function (ticketAbonnementId) {
        window.baorequire(["ViewModels/Dialogs/TicketAbonnementDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(ticketAbonnementId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddTicketAbonnement(dialog.DialogViewModel);
                }
            });
        });
    };
    self.AddTicketAbonnement = function (model) {
        tabPage.IsLoading(true);
        Bao.post("TicketAbonnement/AddTicketAbonnement", JSON.stringify({
            ticketAbonnementModel: ko.map.toJS(model)
        }), function () {
            self.RefreshGrid();
        });
    };
    self.DeleteTicketAbonnement = function (ticketAbonnementId) {
        self.RefreshInProgress(true);
        Bao.post("TicketAbonnement/DeleteTicketAbonnement", JSON.stringify({
            ticketAbonnementId: ticketAbonnementId
        }), function () {
            self.RefreshInProgress(false);
            self.RefreshGrid();
        });
    };
}
Bao.inherit(TicketAbonnementViewModel, BaseViewModel);
TicketAbonnementViewModel.prototype.PermissionRefresh = "TicketAbonnementRefresh";
export default TicketAbonnementViewModel;